import React, { useRef, useState } from "react";
import SearchBar from "../SearchBar";
import { Grid, styled, Box, TextField } from "@mui/material";
import ButtonComponent from "../Button";
import Dropdown from "../FilterDropdown";
import { leadOptions, callOptions } from "../../data/data";
import { LoadScript, Autocomplete } from "@react-google-maps/api";

const StyledBox = styled(Box)(({ theme }) => ({
  padding: "10px",
  borderRadius: "15px",
  backgroundColor: "rgba(0, 176, 80, 0.05)",
  "& .displayEnd": {
    display: "flex",
    justifyContent: "flex-end",
    backgroundColor: "rgba(0, 0, 0, 0.02)",
    paddingTop: "10px",
    columnGap: "8px",
    [theme.breakpoints.down("md")]: {
      columnGap: "0px",
    },
  },
  "& .MuiInputBase-root": {
    color: "#0B1426 !important",
    height: "44px",
    backgroundColor: "transparent",
  },
  "& .MuiOutlinedInput-input": {
    color: "#0B1426",
  },
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    marginBottom: theme.spacing(1),
  },
  "& > *": {
    width: "100%",
  },
}));

const libraries = ["places"];

const Filter = ({
  searchPlaceholder,
  onSearch,
  onLeadStatusChange,
  onCallStatusChange,
  onLocationChange
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [leadStatus, setLeadStatus] = useState("");
  const [location, setLocation] = useState("");
  const [callStatus, setCallStatus] = useState("");
  const autocompleteRef = useRef(null);

  const handleSearch = (event, value) => {
    setSearchQuery(value);
    onSearch(value);
  };

  const handleLeadStatusChange = (selectedValue) => {
    const selectedOption = leadOptions.find(
      (option) => option.label === selectedValue
    );

    if (selectedOption) {
      setLeadStatus(selectedOption.value);
      onLeadStatusChange(selectedOption.value);
    }
  };

  const handleCallStatusChange = (selectedValue) => {
    const selectedOption = callOptions.find(
      (option) => option.label === selectedValue
    );

    if (selectedOption) {
      setCallStatus(selectedOption.value);
      onCallStatusChange(selectedOption.value);
    }
  };


  const onPlaceSelected = () => {
    const place = autocompleteRef.current?.getPlace();
    if (place?.formatted_address) {
      setLocation(place.formatted_address);
      onLocationChange?.(place.formatted_address);
    }
  };


  const handleClear = () => {
    setSearchQuery("");
    setLeadStatus("");
    setCallStatus("");
    setLocation("");

    onSearch("");
    onLeadStatusChange("");
    onCallStatusChange("");
    onLocationChange?.("");

  };

  return (
    <StyledBox>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm={4} md={3}>
          <SearchBar
            placeholder={searchPlaceholder}
            onSearch={handleSearch}
            value={searchQuery}
            options={[]}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_CONSOLE}
            libraries={libraries}
          >
            <Autocomplete
              onLoad={(ref) => (autocompleteRef.current = ref)}
              onPlaceChanged={onPlaceSelected}
            >
              <TextField
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                placeholder="Search Location"
                variant="outlined"
                fullWidth
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '100px',
                  },
                }}
              />
            </Autocomplete>
          </LoadScript>
        </Grid>


        <StyledGrid item xs={12} sm={6} md={2}>
          <Dropdown
            options={leadOptions.map((option) => option.label)}
            onChange={handleLeadStatusChange}
            value={
              leadOptions.find((option) => option.value === leadStatus)
                ?.label || ""
            }
            placeholder="Lead Status"
          />
        </StyledGrid>

        <StyledGrid item xs={12} sm={6} md={2}>
          <Dropdown
            options={callOptions.map((option) => option.label)}
            onChange={handleCallStatusChange}
            value={
              callOptions.find((option) => option.value === callStatus)
                ?.label || ""
            }
            placeholder="Disposition Status"
          />
        </StyledGrid>



        <Grid item xs={12} sm={6} md={2}>
          <ButtonComponent
            name="Reset Filter"
            borderRadius="100px"
            backgroundColor="rgba(0, 0, 0, 0.05)"
            color="black"
            onClick={handleClear}
            width={"100%"}
            margin={"0px"}
            height={"45px"}
          />
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export default Filter;

